import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { IPaginatedApiResponse } from "../../../../utils/types/api-response";
import { handleRemoveEmptyParamFromQueryParams } from "../../../../utils/helpers";
import { getClientForms } from "../../services/client-forms.services";
import {
    IClientFormFilters,
    IClientForm,
} from "../../types/client-forms.types";

export function useGetClientForms(filters: IClientFormFilters) {
    return useQuery<
        IPaginatedApiResponse<IClientForm[]>,
        AxiosError<IPaginatedApiResponse<IClientForm[]>>
    >({
        queryKey: [
            "client-forms",
            handleRemoveEmptyParamFromQueryParams(filters),
        ],
        queryFn: () => getClientForms(filters),
    });
}
